/* eslint-disable import/no-default-export, max-lines-per-function, react/prop-types */
import CheckIcon from "assets/icons/check.svg";
import { cn } from "tailwind-variants";

export default function PinEscalationCard({
  isConfirming = false,
  isCancelling = false,
  compact = false,
  // @ts-expect-error TS migration
  onConfirm,
  // @ts-expect-error TS migration
  onCancel,
  ...restProps
}) {
  return (
    <div
      {...restProps}
      className={cn(
        "rounded-lg border-[1.5px] border-gray-200 bg-gray-100",
        compact ? "p-2" : "p-3",
        // @ts-expect-error TS migration
        restProps.className
      )}
      data-testid="pinning-escalation-card"
    >
      <div className="flex items-center gap-2">
        <p className="m-0 text-[10px] font-bold uppercase tracking-wide text-gray-900">
          {" "}
          Professional edit required{" "}
        </p>
        <span className="rounded-full bg-[#00834F] px-1.5 py-0.5 text-xs font-medium text-white">
          {" "}
          Free{" "}
        </span>
      </div>
      <p className={cn("m-0 mt-1 text-gray-900", compact ? "text-xs" : "text-sm")}>
        {" "}
        Our artists will handle this after checkout.{" "}
      </p>
      <div className={cn("flex gap-2", compact ? "mt-2" : "mt-3")}>
        <button
          className={cn(
            "rounded-lg border border-gray-300 bg-white px-3.5 py-2 text-xs font-medium text-gray-900 [font-family:inherit] hover:bg-gray-50 disabled:pointer-events-none disabled:opacity-25",
            compact && "flex-1"
          )}
          type="button"
          disabled={isConfirming || isCancelling}
          data-testid="pinning-escalation-cancel"
          onClick={() => {
            onCancel();
          }}
        >
          {isCancelling ? "Cancelling\u2026" : "No, discard request"}
        </button>
        <button
          className={cn(
            "flex items-center justify-center gap-1 rounded-lg border border-[#00834F] bg-[#00834F] px-3.5 py-2 text-xs font-medium !text-white [font-family:inherit] hover:bg-[#006B40] disabled:pointer-events-none disabled:opacity-25",
            compact && "flex-1"
          )}
          type="button"
          disabled={isConfirming || isCancelling}
          data-testid="pinning-escalation-confirm"
          onClick={() => {
            onConfirm();
          }}
        >
          <CheckIcon className="h-4 w-4" data-testid="h-4" />{" "}
          {isConfirming ? "Sending\u2026" : "Yes, Send to Artist"}
        </button>
      </div>
    </div>
  );
}
